module.exports = __webpack_public_path__ + "img/hotel-purple.76acb277.png";